import { z } from 'zod';

export const HeaderZodValidators = {
  name: z
    .string()
    .min(1, 'The header name is required')
    .max(128, 'The header name must contain at most 128 characters')
    .regex(
      /^[A-Za-z][A-Za-z0-9-]*$/,
      'The header name must start with a letter and must not contain any whitespace or special characters except hyphens',
    ),
  value: z
    .string()
    .min(1, 'The header value is required')
    .max(4096, 'The header value must contain at most 4096 characters'),
};
